/*
 * Copyright (c) 2022. Revo Digital 
 * ---
 * Author: gabrielecavallo
 * File: FilterableList.tsx
 * Project: mle-client-n 
 * Committed last: 2022/11/29 @ 96
 * ---
 * Description:
 */

import {QueryList} from "@blueprintjs/select";
import {Button, InputGroup, MenuItem, NonIdealState} from "@blueprintjs/core";
import {
    MyLabelPrecompiledField
} from "../../../store/features/shape/precompiled/factory/mylabel/MyLabelPrecompiledFieldFactory";
import Fuse from 'fuse.js'
import {PrecompiledBase} from "../../../store/features/shape/precompiled/factory/abstract/AbstractPrecompiledFactory";
import FuseResult = Fuse.FuseResult;
import IFuseOptions = Fuse.IFuseOptions;


interface Props<T extends PrecompiledBase> {
    data: T[];
    filterable?: boolean;
    onClick: (t: T) => void;
}

export const PrecompiledFilterableList = <T extends PrecompiledBase>(props: Props<T>) => {
    let queryList: QueryList<MyLabelPrecompiledField>;

    return (
        <QueryList
            ref={ref => {
                queryList = ref as any;
            }}
            itemPredicate={(query, item) => {
                if (!query || query == '' || query.length < 3) return true;

                const options: IFuseOptions<any> = {
                    includeScore: true,
                    keys: ['label'],
                    minMatchCharLength: 3,
                }

                const fuse = new Fuse([item], options)
                const result: FuseResult<any>[] = fuse.search(query);

                return (result.length > 0)
            }}
            itemRenderer={(item, itemProps) => {
                return <MenuItem icon={item.iconName} text={item.label} onClick={itemProps.handleClick}/>
            }} renderer={(listProps) => {

            const input = (<InputGroup
                leftIcon="search"
                placeholder="Cerca..."
                rightElement={listProps.query.length > 0 ?
                    <Button icon="cross"
                            minimal={true}
                            onClick={() => {
                                if (queryList && queryList)
                                    queryList.setQuery("", true)
                            }}/> : undefined}
                onChange={listProps.handleQueryChange}
                value={listProps.query}
            />);

            return (<div>
                {
                    input
                }
                <div className="h-80 overflow-y-auto">
                    {
                        listProps.filteredItems.length > 0 ? listProps.itemList :
                            <NonIdealState icon="projects" title="Nessun risultato"
                                           description="Prova a cambiare il termine di ricerca"/>
                    }
                </div>
            </div>)
        }} onItemSelect={props.onClick} items={props.data}/>
    )
}